import { render, staticRenderFns } from "./NoticiasAdministracao.vue?vue&type=template&id=44922ca4&scoped=true"
import script from "./NoticiasAdministracao.vue?vue&type=script&lang=js"
export * from "./NoticiasAdministracao.vue?vue&type=script&lang=js"
import style0 from "./NoticiasAdministracao.vue?vue&type=style&index=0&id=44922ca4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44922ca4",
  null
  
)

export default component.exports